<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Start Table -->
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4 no-footer"
            >
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_length" id="datatable_length">
                    <label
                      >Show
                      <select
                        name="datatable_length"
                        aria-controls="datatable"
                        v-model="perPage"
                        class="
                          custom-select custom-select-sm
                          form-control
                          form-control-sm
                          form-select
                          form-select-sm
                        "
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="datatable_filter" class="dataTables_filter">
                    <label
                      >Search:<input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder=""
                        aria-controls="datatable"
                        v-model.trim="search"
                    /></label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <b-table
                    class="
                      table
                      mt-2
                      dt-responsive
                      nowrap
                      w-100
                      dataTable
                      no-footer
                      dtr-inline
                    "
                    id="datatable"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :fields="column"
                    :items="items"
                    :per-page="perPage"
                    :busy="loading"
                    show-empty
                    @sort-changed="sortChanged"
                  >
                    <template #cell(first_name)="data">
                      <router-link
                        :to="
                          '/mpg/contacts/' + data.item.contact_id + '/details'
                        "
                      >
                        {{
                          data.item.last_name +
                          ", " +
                          data.item.first_name +
                          " " +
                          data.item.middle_name
                        }}
                      </router-link>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="row" v-if="rows > 0">
                <div class="col-sm-12 col-md-5">
                  <div
                    class="dataTables_info"
                    id="datatable_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{
                      currentPage * perPage > rows
                        ? rows
                        : currentPage * perPage
                    }}
                    of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7">
                  <div
                    class="dataTables_paginate paging_simple_numbers"
                    id="datatable_paginate"
                  >
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="my-table"
                      v-on:change="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <router-link
                    :to="'/mpg/contacts/create'"
                    class="btn btn-success waves-effect waves-light"
                  >
                    Create Contact
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- End Card Body -->
        </div>
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { contactsService } from '../services/contacts.service'
import moment from 'moment'
import { debounce } from '../helpers'

export default {
  name: 'Contact',
  components: {},
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      items: [],
      count: 0,
      search: '',
      loading: true,
      column: [
        {
          key: 'first_name',
          sortable: true,
          label: 'Full Name',
          class: 'sorting'
        },
        {
          key: 'gender',
          sortable: true,
          label: 'Gender',
          class: 'sorting'
        },
        {
          key: 'date_of_birth',
          sortable: true,
          label: 'Date of Birth',
          class: 'sorting',
          formatter (value) {
            if (value && value !== '') {
              return moment(value).format('MM/DD/YYYY')
            }
          }
        },
        {
          key: 'personal_email',
          sortable: true,
          label: 'Personal Email',
          class: 'sorting'
        },
        {
          key: 'personal_mobile',
          sortable: true,
          label: 'Personal Mobile',
          class: 'sorting'
        },
        {
          key: 'personal_address',
          sortable: true,
          label: 'Personal Address',
          class: 'sorting'
        },
        {
          key: 'linkedin_url',
          sortable: true,
          label: 'Linkedin',
          class: 'sorting'
        },
        {
          key: 'organizations_contacts',
          sortable: true,
          label: 'Current Organizations',
          class: 'sorting',
          formatter (value) {
            const result = []
            if (value) {
              value.forEach((org) => {
                if (org.employment_status === 'active') {
                  result.push(org.organization.name)
                }
              })
            }
            return result.join(', ')
          }
        }
      ],
      sortBy: 'name',
      sortDesc: false
    }
  },
  computed: {
    rows () {
      return this.count
    }
  },
  watch: {
    search: debounce(function (newVal) {
      this.loadData()
    }, 500),
    perPage (newVal) {
      this.loadData()
    },
    sortBy (newVal) {
      this.loadData()
    },
    sortDesc (newVal) {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    moment,
    loadData () {
      this.loading = true
      contactsService
        .getData({
          q: 'q=' + this.search,
          ordering: this.sortDesc ? '-' + this.sortBy : this.sortBy,
          limit: this.perPage,
          offset: (this.currentPage - 1) * this.perPage
        })
        .then((rs) => {
          this.items = rs.results
          this.count = rs.count
          this.loading = false
        })
    },
    sortChanged (e) {
      this.sortDesc = e.sortDesc
      this.sortBy = e.sortBy
    },
    onPageChange (value) {
      this.currentPage = value
      this.loadData()
    },
    onSubmit () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Contact.vue